import {kAboutNavigation} from "../../../constants/navigation";
import AboutDesktopTabBarItem from "../../items/aboutScreen/AboutDesktopTabBarItem";

export default function AboutDesktopTabBar({selectedTab, setSelectedTab}) {
    // Used in AboutScreen to display sections tab bar in desktop mode

    // BUILD
    return (
        <div className={"leading-none w-full border-b border-greyLight7 flex mt-[24px]"}>
            {kAboutNavigation.map((item, index) => (
                <AboutDesktopTabBarItem
                    key={index}
                    item={item}
                    isSelected={selectedTab === index}
                    setSelectedTab={() => setSelectedTab(index)}/>
            ))}
        </div>
    );
}